module.exports = __webpack_public_path__ + "zvetseni-prsou_27_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_27_before.jpg
// module id = 1320
// module chunks = 0